import { render, staticRenderFns } from "./productHost.vue?vue&type=template&id=c9680208&scoped=true&"
import script from "./productHost.vue?vue&type=script&lang=js&"
export * from "./productHost.vue?vue&type=script&lang=js&"
import style0 from "./productHost.vue?vue&type=style&index=0&id=c9680208&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9680208",
  null
  
)

export default component.exports